import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppSelector } from 'hooks';
import { ROUTES } from 'constants/routes';
import { PayloadState } from '../interfaces';

export function PublicRoute() {
  const { user, refreshRequestState } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    console.log(user);
    if (user && refreshRequestState !== PayloadState.rejected) {
      navigate(ROUTES.pdf_history, { replace: true });
    }
  }, [user]);
}
